import { render, staticRenderFns } from "./notes.vue?vue&type=template&id=02192bdc&scoped=true"
import script from "./notes.vue?vue&type=script&lang=js"
export * from "./notes.vue?vue&type=script&lang=js"
import style0 from "./notes.vue?vue&type=style&index=0&id=02192bdc&lang=scss"
import style1 from "./notes.vue?vue&type=style&index=1&id=02192bdc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02192bdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02192bdc')) {
      api.createRecord('02192bdc', component.options)
    } else {
      api.reload('02192bdc', component.options)
    }
    module.hot.accept("./notes.vue?vue&type=template&id=02192bdc&scoped=true", function () {
      api.rerender('02192bdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/course/notes.vue"
export default component.exports